import { inject, injectable } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { VacationsRouter } from '../../../vacations/types';
import { modules } from '../../modules';

@injectable()
export class VacationsRouterService implements VacationsRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToDetail(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.vacations.basename}/${id}`,
    );
  }

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${this.role.get()}/${modules.vacations.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.vacations.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }
}
